/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Set_DefaultInputs */

const cs_templates_set_default = /** @type {(inputs: Templates_Set_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavit jako výchozí`)
};

const en_templates_set_default = /** @type {(inputs: Templates_Set_DefaultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set as default`)
};

/**
* | output |
* | --- |
* | "Set as default" |
*
* @param {Templates_Set_DefaultInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_set_default = /** @type {((inputs?: Templates_Set_DefaultInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Set_DefaultInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_set_default(inputs)
	return cs_templates_set_default(inputs)
});